module.exports = __webpack_public_path__ + "static/media/calendar-date-1.6f5fec41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/calendar-date-1.svg
// module id = 1234
// module chunks = 0